<template>
  <div>
    <div class="page-header clear-filter"  filter-color="black">
      <parallax v-bind:useScroll=false class="page-header-image" style="background-image:url('/img/img_reward.png')"></parallax>
      <div class="container" id="top">
        <div class="row" style="margin-top: 260px;">
          <div data-aos="fade-right" class="col-lg-12" style="text-align: center;">
            <h1
              style="
            font-size: 3em;
            font-weight: 900;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #fff;
            "
            >{{$t(`Coming Soon!!`)}}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax, Button } from "@/components";
import { Popover } from "element-ui";

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    Parallax,
    [Button.name]: Button,
    [Popover.name]: Popover
  },
  methods: {
    goHomepage: async function() {
      let url = "//www.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goLand: async function() {
      let url =
        "//link.medium.com/7qkosArck6";
      if (this.$i18n.locale == "ko") {
        url = "//link.medium.com/85pXZbO5h6";
      }
      else if (this.$i18n.locale == "ch-zn") {
        url = "//bihu.com/article/1016823935";
      }
      window.open(url, "_blank");
    },
    goPresale: async function() {
      let url =
        "//link.medium.com/xN16Bo1Mp6";
      if (this.$i18n.locale == "ko") {
        url = "//link.medium.com/2l6xPJqKo6";
      }
      else if (this.$i18n.locale == "ch-zn") {
        //url = "//bihu.com/article/1016823935";
      }
      window.open(url, "_blank");
    }
  },
  mounted() {},
  data: function() {
    return {};
  }
};
</script>
<style>
</style>
